application.register("lib-nav", class extends Stimulus.Controller {
  connect() {
    const activeItem = this.element.querySelector('[aria-current="page"]')

    if(activeItem) {
      this.setScroll(activeItem)
    }
  }

  setScroll(item) {
    this.element.scroll({left: item.closest('.col').offsetLeft, behavior: 'smooth'})
  }

  setActive({currentTarget}) {
    arguments[0].preventDefault()

    if(currentTarget.classList.contains('state--active')) return

    this.targets.findAll('item').forEach(item => item.classList.remove('state--active'))
    currentTarget.classList.add('state--active')
    this.setScroll(currentTarget)
  }
})
